module.exports = __webpack_public_path__ + "img/nodejs-logo.55e83371.png";